import {logger} from 'yougile-util'

/**
 * Platform events as constants, which YouGile app can rely on, e.g. extensions
 * can trigger them to tell YouGile interface re-render something related
 *
 * That each platform event name should start with the prefix: "000000-..."
 */
type PlatformEvent = '000000-update-extensions-in-column'

type PlatformEventsType = {
  [key: string]: PlatformEvent
}

const platformEvents: PlatformEventsType = {
  updateExtensionsInColumn: '000000-update-extensions-in-column'
} as const

/**
 * @description
 * PlatformEvents
 *
 * Platform events is only for client-side, that can be used e.g.
 * by extensions to communicate with YouGile interface (to trigger some rerenders or etc.).
 *
 * @descriptionRu
 * PlatformEvents
 *
 * События платформы предназначены только для клиентской стороны и могут использоваться, например,
 * расширениями для связи с интерфейсом YouGile (для запуска некоторых повторных рендеров и т. д.).
 */
export class PlatformEvents {
  private static logTag = '[PlatformEvents]'
  private static eventCallbacks: Map<string, Array<() => void>> = new Map()

  public static events: PlatformEventsType = platformEvents

  public static isPlatformEvent(eventName: string): eventName is PlatformEvent {
    return Object.values(platformEvents as unknown as string[]).includes(
      eventName
    )
  }

  public static on(eventName: string, callback: () => void): () => void {
    const callbacks = PlatformEvents.eventCallbacks.get(eventName) ?? []
    callbacks.push(callback)
    PlatformEvents.eventCallbacks.set(eventName, callbacks)

    return () => {
      PlatformEvents.eventCallbacks.set(
        eventName,
        PlatformEvents.eventCallbacks
          .get(eventName)
          .filter(cb => cb !== callback)
      )
    }
  }

  public static trigger(eventName: PlatformEvent): void {
    const callbacks = PlatformEvents.eventCallbacks.get(eventName) ?? []

    for (const callback of callbacks) {
      try {
        callback()
        // logger.log(PlatformEvents.logTag, `event "${eventName}" is fired`)
      } catch (error) {
        logger.error(
          PlatformEvents.logTag,
          'failed while calling local event callback',
          error
        )
      }
    }
  }
}
